<script>
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import PriTama05 from './PriTama05.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },
    mixins: [ PriTama05 ],
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="✨ IR ✨" color="#edd50f" :items="itemsIR" />
      <ItemList title="🥚 ER 🥚" color="#44cd1f" :items="itemsER" />
    </template>

    <template #col2>
      <ItemList title="⭐️ WR ⭐️" color="#ffca59" :items="itemsWR" />
      <ItemList title="👑 FR 👑" color="#ff5d91" :items="itemsFR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col3>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="モーリー限定 SR ★★" color="#55b272" :items="itemsMolly" />
    </template>

    <template #col4>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col5>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
    </template>

    <template #col6>
      <ItemList title="✨ サンキューキャンペーン IR ✨" color="#edd50f" :items="items999CampaignIR" />
      <ItemList title="👑 サンキューキャンペーン FR 👑" color="#ff5d91" :items="items999CampaignFR" />
      <ItemList title="サンキューキャンペーン SR ★★" color="#00c7da" :items="items999CampaignSR" />
    </template>


    <template #col7>
      <ItemList title="ハッピーレア大量発生|チャンネル" color="#ff5d91" :items="itemsHR" />
      <Status :date="date" :items="items" :showKira="true" :showNico="false" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: $size-unit * 221;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }

  // コレクショングループ間の間隔 (IR)
  .Page ::v-deep .Page__col:nth-child(1) .ItemList:nth-child(1) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16) {
      margin-top: $size-unit * 8;
    }
  }
</style>
